var _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMain400ViewBorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 445 85",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#c69c6d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m62.3 54.95v8.8h-11.6v15.6h-9.9v-15.6h-34.6v-8.2l35.4-49.9h9.1v49.3zm-45.4 0h23.9v-33.5s-23.9 33.5-23.9 33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.2 42.45c0-26.4 12.1-37.6 28-37.6s28.1 11.2 28.1 37.6-12.1 37.7-28.1 37.7-28-11.3-28-37.7zm45.5 0c0-17.7-5.1-28-17.5-28s-17.4 10.3-17.4 28 5.1 28 17.4 28 17.5-10.2 17.5-28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m138.5 42.45c0-26.4 12.1-37.6 28-37.6s28.1 11.2 28.1 37.6-12.1 37.7-28.1 37.7-28-11.3-28-37.7zm45.5 0c0-17.7-5.1-28-17.5-28s-17.4 10.3-17.4 28 5.1 28 17.4 28 17.5-10.2 17.5-28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m251.5 5.65h10.9l-24.6 73.71h-12.3l-25.2-73.71h11.2l20.2 61z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m272.5 5.65h10.5v73.7h-10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m309.9 69.95h38.4v9.4h-48.9v-73.7h46.9v9.3h-36.4v22.1h32.9v9.3h-32.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m428.3 5.65h10.5l-16.7 73.71h-12.1l-13.1-58.8-12.9 58.8h-12.1l-17.3-73.71h10.8l12.9 59.7 12.5-59.7h12.1l12.8 59.9s12.6-59.9 12.6-59.9z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m444 1v83h-443v-83zm1-1h-445v85h445z",
    fill: "#666"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMain400ViewBorder);
export default __webpack_public_path__ + "static/media/main_400view_border.3b5fe7307c30c4ee102fde63e067bef0.svg";
export { ForwardRef as ReactComponent };